<!-- /* updateImage from  an video*/ -->
<div class="alert-box" [ngStyle] = "isCanvasShown ?  {'width':'932px'} : {'width' : '300px'}">
    <div class="alert-header">
        <a (click)="closeBox()"><img width="20" src='assets/images/close-commentbox-icon.png'></a>
    </div>
    <div class="alert-content">
        <!-- /* updateImage from  an video*/ -->
        <canvas class="image-content" style="width: 100%;margin-top: 7px;margin-bottom: -6px;" id="myCanvas"></canvas>            
        <span>
            {{message}}
        </span>
        <br><br>
        <div class="col-md-12 text-center"><button class="btn btn-blue" value="close" (click)="closeBox()">Ok</button></div>
    </div>
</div>